import { cn } from '@apps/web/lib/utils';

export function ListPageTabs({
    tabs,
    activeTab,
    onTabChange,
    className,
    colorScheme = 'auto',
    ...props
}: {
    readonly tabs: ReadonlyArray<{
        readonly id: string;
        readonly label: string;
    }>;
    readonly activeTab: string;
    readonly onTabChange: (id: string) => void;
    readonly className?: string;
    readonly colorScheme?: 'auto' | 'light';
    readonly 'aria-label': string;
    readonly 'data-testid'?: string;
}) {
    return (
        <div className={cn('@container/list-page-tabs min-w-0', className)}>
            <nav
                {...props}
                className={cn(
                    'flex gap-6 overflow-x-auto border-b border-[#dbe3e3] @max-[600px]/list-page-tabs:gap-5',
                    colorScheme === 'auto' && 'dark:border-border',
                )}
            >
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        type="button"
                        aria-current={activeTab === tab.id ? 'page' : undefined}
                        className={cn(
                            '-mb-px min-h-9 shrink-0 cursor-pointer border-0 border-b-2 border-transparent bg-transparent p-0 pb-3 text-sm font-medium whitespace-nowrap text-[#617578] outline-offset-3 focus-visible:outline-2 focus-visible:outline-[#5533ee] aria-[current=page]:border-[#002429] aria-[current=page]:text-[#002429] @max-[600px]/list-page-tabs:min-h-11 @max-[600px]/list-page-tabs:text-[0.8125rem]',
                            colorScheme === 'auto' &&
                                'dark:text-muted-foreground dark:aria-[current=page]:border-foreground dark:aria-[current=page]:text-foreground',
                        )}
                        onClick={() => onTabChange(tab.id)}
                    >
                        {tab.label}
                    </button>
                ))}
            </nav>
        </div>
    );
}
